import React from "react"
import {styled} from "@mui/material"

export const widgetDotPrototype = [
    {
        key: "color",
        type: "COLOR",
        label: "Farbe",
        size: 3,
    },
]

const Dot = styled("div")((props) => ({
    width: "16px",
    height: "16px",
    borderRadius: "16px",
    backgroundColor: props.color,
}))

const WidgetDot = ({widget, value}) => {
    const color = value ?? widget?.color
    return <Dot color={color}/>
}

export default WidgetDot